import React, { useEffect, useState, useCallback, useMemo } from 'react';
import './index.css';
import { DashBoardTitle } from '../../Title';
import { Col, Container, Row, Table } from 'reactstrap';
import CustomSpinner from '../../CustomSpinner/CustomSpinner';
import Pagination from '../../Pagination/Pagination';
import { getOrderSummaryCountWithStatus } from '../../../constants/apiCalls';
import { useNavigate, useParams } from 'react-router-dom';
import { BreadCrumbBackButton } from '../../Breadcrumbs/BreadCrumbBackButton';
import { Breadcrumbs } from '../../Breadcrumbs/Breadcrumbs';
import Storage from '../../../services/Storage';
import { UserFilters } from '../../Filters';
import ModalService from '../../../services/ModalService';
import { handleErrorMessage } from '../../../utils/utils';
import DateService from '../../../services/DateService';
import { messages } from '../../../utils/constant-messages';
import { Permissions } from '../../../constants/Permissions';
import { Roles } from '../../../constants/Roles';
import { useSelector } from 'react-redux';
import OrderSummaryGeneralModal from '../../CustomModal/OrderSummaryGeneral/OrderSummaryGeneral';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';
import moment from 'moment';

export function OrderSummaryTableFTD() {
  const params = useParams();
  const navigate = useNavigate();
  // const localPermission = Storage.getUserPermissionDetail();
  const { permissionArr } = useSelector((state) => state.UserGetReducer);

  const [orderSummaryModalOpen, setOrderSummaryModalOpen] = useState(false);
  const [orderSummaryModalData, setOrderSummaryModalData] = useState(null);

  const localPermission = permissionArr;
  let userInfo = Storage.getUserInfoDetail();
  let roleName = userInfo ? userInfo.role : '';
  useEffect(() => {
    if (!localPermission.includes(Permissions.ORDER_SUMMARY)) {
      navigate('/');
    }
  }, [...localPermission]);

  let pageNo = useMemo(() => Storage.getOrderPage(), [Storage.getOrderPage()]);

  const [orderData, setOrderData] = useState([]);

  // Page
  const [count, setCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(Number(pageNo) ? Number(pageNo) : 1);
  const [pageSize, setPageSize] = useState(10);

  // Date
  const [startDate, setStartDate] = useState(
    `${params.pagetype.includes('mtd')
      ? Storage.getDashboardCurrentFirstDate()
      : Storage.getDashboardCurrentDate()
    }`,
  );
  const [endDate, setEndDate] = useState(Storage.getDashboardCurrentDate());
  const [isLoading, setIsloading] = useState(false);

  // Modal
  const [object, setObject] = useState('');

  let userDataAll = Storage.getBreadcrumbsrRecord();
  let userData = useMemo(
    () =>
      userDataAll.reduce((unique, o) => {
        if (!unique.some((obj) => obj.id === o.id && obj.role === o.role)) {
          if (o.filter) {
            unique.push(o.filter);
          }
        }
        return unique;
      }, []),
    [],
  );

  const getDealerData = useCallback(
    (obj, page, pageSize) => {
      setIsloading(true);
      setObject(obj);
      let payload = {
        q: obj.searchQuery || '',
        pagesize: pageSize,
        page: page || 1,
        start_date: obj.startDate ? obj.startDate : '',
        end_date: obj.endDate ? obj.endDate : '',
        nh: obj.nhId || null,
        sh: obj.shId || null,
        th: obj.tmId || null,
        state_id: obj.stateId || null,
        territory_id: obj.territoryId || null,
        product_id: obj.productId || null,
        is_download: false,
      };
      getOrderSummaryCountWithStatus((res) => {
        const { data, success, error } = res;
        if (success === true) {
          setOrderData(data.data);
          let count = data.total_count;
          setCount(count);
          let totalPages = Math.ceil(count / pageSize);
          setTotalPages(totalPages);
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
      }, payload);
    },
    [object, page, pageSize],
  );

  const handleExcelSheet = useCallback(
    (obj, page, pageSize) => {
      let payload = {
        q: obj.searchQuery || '',
        pagesize: 100000,
        page: page || 1,
        start_date: obj.startDate ? obj.startDate : '',
        end_date: obj.endDate ? obj.endDate : '',
        nh: obj.nhId || null,
        sh: obj.shId || null,
        th: obj.tmId || null,
        state_id: obj.stateId || null,
        territory_id: obj.territoryId || null,
        product_id: obj.productId || null,
        is_download: true,
      };
      getOrderSummaryCountWithStatus((res) => {
        const { data, success, error } = res;
        if (success === true) {
          window.open(data.file, '_blank');
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
        setIsloading(false);
      }, payload);
    },
    [object, page, pageSize],
  );

  const handlePageChange = useCallback(
    (page) => {
      setPage(page);
      Storage.setOrderPage(Number(page));
      getDealerData(object, page, pageSize);
    },
    [object, page, pageSize],
  );

  const handleInputChange = useCallback(
    (e) => {
      let pageSize = parseInt(e.target.value);
      setPageSize(pageSize);
      setPage(1);
      getDealerData(object, page, pageSize);
    },
    [object, page, pageSize],
  );

  const handleOrderSummaryModal = (data) => {
    setOrderSummaryModalData(data);
    setOrderSummaryModalOpen(true);
  };

  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id="orderSummaryFTDTable">
              {isLoading && <CustomSpinner />}
              <div className="pageWrapper">
                <Container fluid>
                  <Row>
                    <Col xs={12}>
                      <div className="pageheader">
                        <DashBoardTitle
                          dashBorardName={`Order Summary ${params.pagetype.includes('mtd') ? 'MTD' : 'FTD'
                            }`}
                        />
                        <BreadCrumbBackButton />
                      </div>
                    </Col>
                    <Col xs={12}>
                      <Breadcrumbs title="Order Summary" />
                    </Col>
                    <Col xs={12}>
                      <UserFilters
                        page={page}
                        setPage={setPage}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                        pageNo={pageNo}
                        userData={userData}
                        startDate={startDate}
                        setStartDate={setStartDate}
                        endDate={endDate}
                        setEndDate={setEndDate}
                        dealerData={getDealerData}
                        excelData={handleExcelSheet}
                      />
                    </Col>
                    <Col xs={12}>
                      <div className="commonNote mt-3 mb-1">
                        Note : Order summary is showing for the Individual products and
                        it’s highlighted with same color by group of one order.
                      </div>
                    </Col>
                  </Row>
                  {orderData.length && count > 0 ? (
                    <Row>
                      <Col xs={12}>
                        <div className="table-responsive dealerTable">
                          <Table bordered className="table text-center">
                            <thead>
                              <tr>
                                <th>Order Date</th>
                                <th>Order Number</th>
                                <th>Dealer Code</th>
                                <th>Dealership Name</th>
                                <th>Invoice Date</th>
                        <th>Invoice Number</th>
                        <th>Status</th>
                                <th>Mobile</th>
                                <th>Product Name</th>
                                <th>Qty/Accepted</th>
                        <th>Total/Accepted</th>
                                {/* <th>Qty</th>
                                <th>Total</th> */}
                                {roleName !== Roles.TM_NAME && <th>TM</th>}
                              </tr>
                            </thead>
                            <tbody>
                              {orderData.map((elem, index) => {
                                const {
                                  order_id,
                                  dealer_code,
                                  color,
                                  business_name,
                                  primary_contact_mobile,
                                  product_name,
                                  qty,
                                  action,
                                  order_date,
                                  accepted_quantity,
                                  no_of_packages,
                                  invoice_date,
                                  invoice_no,
                                  total_quantity,
                                  unit,
                                  unit_type,
                                  th,
                                } = elem;
                                return (
                                  <tr key={index} style={{ backgroundColor: color }}>
                                    <td>
                                      {DateService.utcToLocalDate(order_date) || 'N/A'}
                                    </td>
                                    <td
                                      onClick={() => handleOrderSummaryModal(elem)}
                                      style={{
                                        color: 'blue',
                                        textDecoration: 'underline',
                                        cursor: 'pointer',
                                      }}
                                    >
                                      {order_id}
                                    </td>
                                    <td>{dealer_code}</td>
                                    <td>
                                      <span>{business_name}</span>
                                    </td>
                                    <td>
                              {invoice_date
                                ? moment(invoice_date).format('DD-MM-YYYY')
                                : '-'}
                            </td>
                            <td>{invoice_no || '-'}</td>
                            <td>{action}</td>

                                    <td>{primary_contact_mobile}</td>
                                    <td>{product_name}</td>
                                    <td>
                              {qty}/{no_of_packages || ' -'}
                            </td>
                            <td>
                              {action === 'Pending'
                                ? `${total_quantity} ${unit_type}`
                                : `${total_quantity} / ${accepted_quantity ||
                                ' -'}`}
                            </td>
                                    {/* <td>
                                      {qty}
                                    </td>
                                    <td>
                                      {total_quantity} {unit_type}
                                    </td> */}
                                    {roleName !== Roles.TM_NAME && <td>{th}</td>}
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                      </Col>
                      <Col xs={12}>
                        <div className="paginationWrapper">
                          <span className="page-select-title">Rows per page:</span>
                          &nbsp;&nbsp;
                          <select
                            className="form-control rows-per-page-select"
                            name="pageSize"
                            value={pageSize}
                            onChange={(e) => handleInputChange(e)}
                          >
                            <option key="5" value="5">
                              5 Rows
                            </option>
                            <option key="10" value="10">
                              10 Rows
                            </option>
                            <option key="15" value="15">
                              15 Rows
                            </option>
                            <option key="20" value="25">
                              25 Rows
                            </option>
                            <option key="25" value="30">
                              30 Rows
                            </option>
                            <option key="30" value="50">
                              50 Rows
                            </option>
                          </select>
                          &nbsp;&nbsp;
                          <div className="pageList">
                            <Pagination
                              margin={2}
                              page={page}
                              count={parseInt(totalPages)}
                              pageSize={pageSize}
                              totalRecords={parseInt(count)}
                              onPageChange={handlePageChange}
                            ></Pagination>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col xs={12}>{messages.COMMON.NO_RECORD_MATCH}</Col>
                    </Row>
                  )}
                </Container>

                {orderSummaryModalOpen && (
                  <OrderSummaryGeneralModal
                    isOpen={orderSummaryModalOpen}
                    orderData={orderSummaryModalData}
                    toggle={() => {
                      setOrderSummaryModalOpen(!orderSummaryModalOpen);
                      setOrderSummaryModalData(null);
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}